import React, { useEffect } from "react";
import {BrowserRouter} from "react-router-dom";
import AppRoutes from "./routes.js";
import "../src/styles/calendar.style.css";
import { LanguageProvider } from "./utils/languageContext.js";
import { DarkModeProvider } from "./utils/darkModeContext.js";
import { AuthProvider } from "./utils/authContext.js";
import { SidebarProvider } from "./utils/sidebarContext.js";
import AuthErrorBoundary from "./components/ErrorBoundary/AuthErrorBoundary.js";

const App = () => {
    useEffect(() => {
        // Listen for the beforeinstallprompt event
        const handleBeforeInstallPrompt = (e) => {
            // Prevent the default prompt
            e.preventDefault();
            // Store the event for later use
            window.deferredPrompt = e;
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        // Clean up when component unmounts
        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };
    }, []);

    return (
        <AuthErrorBoundary>
            <AuthProvider>
                <DarkModeProvider>
                    <LanguageProvider>
                        <SidebarProvider>
                            <BrowserRouter future={{
                                v7_startTransition: true,
                                v7_relativeSplatPath: true,
                            }}>
                                <AppRoutes/>
                            </BrowserRouter>
                        </SidebarProvider>
                    </LanguageProvider>
                </DarkModeProvider>
            </AuthProvider>
        </AuthErrorBoundary>
    );
};
export default App;
